export default __webpack_public_path__ + "static/media/confirmBudgetActive.f9779df1.svg";